export enum TAB_KEY {
    HOURS = 'hours',
    DAYS_1_4 = '1-4days',
    DAYS_5_PLUS = '5days+',
    WHOLE_HOME = '24-7',
}

export interface ImageConfig {
    pc: string;
    h5: string;
}

export interface ConsultCardConfig {
    label: string;
    title: string;
    desc: string;
    btn: string;
    img: ImageConfig;
    href: string;
}

export interface ProductConfig {
    productId: string;
    variantId: string;
    label: string;
    desc: string;
    skuTitle?: string;
    imgs?: string[];
    href?: string;
}

export interface TabDataConfig {
    tabLabel: string;
    label: string;
    title: string;
    desc: string;
    image: ImageConfig;
    products: ProductConfig[];
    consultCard?: ConsultCardConfig;
}

type TranslateFn = (key: string) => string;

const TABS_CONFIG_MAP: Record<string, (t: TranslateFn) => Record<TAB_KEY, TabDataConfig>> = {
    us: (t: TranslateFn) => ({
        [TAB_KEY.DAYS_5_PLUS]: {
            tabLabel: '5 Days+',
            label: t('label3'),
            title: t('title3'),
            desc: t('desc3'),
            image: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767691691252-987ojg-compressed-full-width-carousel.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1767691740655-mntvvq-compressed-Frame%202094654869.jpg',
            },
            products: [
                {
                    productId: '15391292588105',
                    variantId: '54714781171785',
                    label: t('i3_product1_label'),
                    desc: t('i3_product1_desc'),
                    skuTitle: '1 × EcoFlow DELTA Pro Ultra X Inverter + 2 × Smart Extra Battery',
                },
                {
                    productId: '6964802453577',
                    variantId: '55686961168457',
                    label: t('i3_product2_label'),
                    desc: t('i3_product2_desc'),
                    skuTitle: '1 × EcoFlow DELTA Pro Ultra Inverter + 3 × Smart Extra Battery',
                },
                {
                    productId: '6964802453577',
                    variantId: '41748275626057',
                    label: t('i3_product3_label'),
                    desc: t('i3_product3_desc'),
                    skuTitle: '1 × EcoFlow DELTA Pro Ultra Inverter + 2 × Smart Extra Battery',
                },
            ],
        },
        [TAB_KEY.DAYS_1_4]: {
            tabLabel: '1-4 Days',
            label: t('label2'),
            title: t('title2'),
            desc: t('desc2'),
            image: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767691680678-0ukmhq-compressed-full-width-carousel.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1767691729271-qvdowv-compressed-Frame%202094654868.jpg',
            },
            products: [
                {
                    productId: '6964802453577',
                    variantId: '40758830071881',
                    label: t('i2_product1_label'),
                    desc: t('i2_product1_desc'),
                    skuTitle: '1 × EcoFlow DELTA Pro Ultra Inverter + 2 × Smart Extra Battery',
                },
                {
                    productId: '7185477075017',
                    variantId: '41385721004105',
                    label: t('i2_product2_label'),
                    desc: t('i2_product2_desc'),
                    skuTitle: 'EcoFlow DELTA Pro 3',
                },
                {
                    productId: '6585086836809',
                    variantId: '40516140138569',
                    label: t('i2_product3_label'),
                    desc: t('i2_product3_desc'),
                    skuTitle: 'EcoFlow DELTA Pro',
                },
                {
                    productId: '15386143096905',
                    variantId: '54718705008713',
                    label: t('i2_product4_label'),
                    desc: t('i2_product4_desc'),
                    skuTitle: 'EcoFlow DELTA 3 Ultra Plus',
                },
            ],
        },
        [TAB_KEY.HOURS]: {
            tabLabel: 'Hours',
            label: t('label1'),
            title: t('title1'),
            desc: t('desc1'),
            image: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767691664174-fwndy3-compressed-full-width-carousel.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1767691718817-3is95o-compressed-Frame%202094654867.jpg',
            },
            products: [
                { productId: '7289136054345', variantId: '41826182496329', label: t('i1_product4_label'), desc: t('i1_product4_desc') },
                { productId: '15386067730505', variantId: '54691871227977', label: t('i1_product5_label'), desc: t('i1_product5_desc') },
                { productId: '7290968473673', variantId: '41636514136137', label: t('i1_product2_label'), desc: t('i1_product2_desc') },
                { productId: '7290965622857', variantId: '41636504305737', label: t('i1_product1_label'), desc: t('i1_product1_desc') },
                // { productId: '7394893463625', variantId: '42015827492937', label: t('i1_product3_label'), desc: t('i1_product3_desc') },
                // { productId: '7323318190153', variantId: '41719074324553', label: t('i1_product6_label'), desc: t('i1_product6_desc') },
            ],
        },
        [TAB_KEY.WHOLE_HOME]: {
            tabLabel: '24/7',
            label: t('label4'),
            title: t('title4'),
            desc: t('desc4'),
            image: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1767691703014-zspo0b-compressed-full-width-carousel.jpg',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1767691752586-qtkhiw-compressed-Frame%202094654870.jpg',
            },
            products: [
                {
                    productId: '15391292588105',
                    variantId: '55651750969417',
                    label: t('i4_product1_label'),
                    desc: t('i4_product1_desc'),
                    skuTitle: '1 × EcoFlow DELTA Pro Ultra X Inverter + 4 × Smart Extra Battery + 1 ×Smart Home Panel 3',
                },
                {
                    productId: '15391292588105',
                    variantId: '54714781270089',
                    label: t('i4_product2_label'),
                    desc: t('i4_product2_desc'),
                    skuTitle: '2 × EcoFlow DELTA Pro Ultra X Inverter + 4 × Smart Extra Battery + 1 ×Smart Home Panel 3',
                },
                {
                    // 这个品Power Ocean就是没id
                    productId: '',
                    variantId: '',
                    label: t('i4_product_label'),
                    skuTitle: t('i4_product_title'),
                    desc: t('i4_product_desc'),
                    // btn: t('i4_product_btn'),
                    imgs: [
                        'https://websiteoss.ecoflow.com/upload/image/1753067523603/i4-product.png',
                        'https://websiteoss.ecoflow.com/upload/image/1753067523525/i4-product-h5.png',
                    ],
                    href: 'https://www.ecoflow.com/us/ocean-pro-consultation?utm_source=oceanpro&utm_medium=orderpage',
                },
            ],
            // consultCard: {
            //     label: t('i4_product_label'),
            //     title: t('i4_product_title'),
            //     desc: t('i4_product_desc'),
            //     btn: t('i4_product_btn'),
            //     img: {
            //         pc: 'https://websiteoss.ecoflow.com/upload/image/1753067523603/i4-product.png',
            //         h5: 'https://websiteoss.ecoflow.com/upload/image/1753067523525/i4-product-h5.png',
            //     },
            //     href: 'https://www.ecoflow.com/us/ocean-pro-consultation?utm_source=oceanpro&utm_medium=orderpage',
            // },
        },
    }),
    au: (t: TranslateFn) => ({
        [TAB_KEY.HOURS]: {
            tabLabel: t('secD_btn1'),
            label: t('label1'),
            title: t('title1'),
            desc: t('desc1'),
            image: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1785231915836-y1lg37-compressed-Frame%201612708366.webp',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1785232435129-v4qy1t-compressed-Frame%202094655112.webp',
            },
            products: [
                { productId: '8435739197638', variantId: '44378294452422', label: t('i1_product1_label'), desc: t('i1_product1_desc') },
                { productId: '8435739197638', variantId: '45556169736390', label: t('i1_product2_label'), desc: t('i1_product2_desc') },
            ],
        },
        [TAB_KEY.DAYS_1_4]: {
            tabLabel: t('secD_btn2'),
            label: t('label2'),
            title: t('title2'),
            desc: t('desc2'),
            image: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1785231924078-7y78s1-compressed-Frame%202094655104.webp',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1785232449199-gr5qvg-compressed-Frame%202094655110.webp',
            },
            products: [
                { productId: '8554314727622', variantId: '44762205061318', label: t('i2_product5_label'), desc: t('i2_product5_desc') },
                { productId: '8311879925958', variantId: '44062870503622', label: t('i2_product1_label'), desc: t('i2_product1_desc') },
            ],
        },
        [TAB_KEY.DAYS_5_PLUS]: {
            tabLabel: t('secD_btn3'),
            label: t('label3'),
            title: t('title3'),
            desc: t('desc3'),
            image: {
                pc: 'https://websiteoss.ecoflow.com/figma-uploads/1785231931890-edv9k6-compressed-Frame%202094655105.webp',
                h5: 'https://websiteoss.ecoflow.com/figma-uploads/1785232455215-je69qc-compressed-Frame%202094655111.webp',
            },
            products: [
                {
                    productId: '7756526584006',
                    variantId: '42673598824646',
                    label: t('i3_product1_label'),
                    desc: t('i3_product1_desc'),
                    skuTitle: '1 × EcoFlow DELTA Pro Ultra X Inverter + 2 × Smart Extra Battery',
                },
                {
                    productId: '8462188118214',
                    variantId: '44457406922950',
                    label: t('i3_product2_label'),
                    desc: t('i3_product2_desc'),
                    skuTitle: '1 × EcoFlow DELTA Pro Ultra X Inverter + 2 × Smart Extra Battery + 1 × EcoFlow Smart Home Panel 3',
                },
            ],
        },
    }),
};

export const getTabsConfig = (t: TranslateFn, locale = 'us') => {
    const getTabData = TABS_CONFIG_MAP[locale] || TABS_CONFIG_MAP.us;
    const tabData = getTabData(t);

    return Object.entries(tabData).map(([key, data]) => ({
        key: key as TAB_KEY,
        ...data,
    }));
};
